import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button, TextField } from '@mui/material';
import { BackdropLoader, toast } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
// import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useStylesVoidStatementModalContent from './styles';
export const VoidStatementModalContent = observer(props => {
  const store = useStore();
  const classes = useStylesVoidStatementModalContent();
  // const { t } = useTranslation();

  const handleModalClose = props.handleModalClose,
    id = props.id,
    setTriggerRefresh = props.setTriggerRefresh;
  const paperStatementId = id || store.payment.statementId;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    voidReason = _useState4[0],
    setVoidReason = _useState4[1];
  const handleSubmit = async () => {
    setIsLoading(true);
    await store.statement.voidStatementAsync.run({
      paperStatementId,
      voidReason
    }).then(() => {
      setTriggerRefresh(true);
      toast('success', {
        body: ['Successfully voided. Please check the transaction history']
      }); // ? i18n
    }).finally(() => {
      setIsLoading(false);
      handleModalClose();
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "reason",
    label: 'Reason for voiding',
    onChange: e => setVoidReason(e.target.value),
    value: voidReason,
    variant: "outlined"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleSubmit,
    variant: "contained",
    'custom-attribute': '817-resident-profile-page-void-statement'
  }, "Void statement")), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }));
});